export const addProject = '/projects';
export const getProjects = '/projects';
export const updateProjectStatus = '/projects/updateProjectStatus/';
export const getProjectDetails = '/projects/';
export const updateProject = '/projects/';
export const deleteProject = '/projects/';
